<template>
  <div class="red-invoice-confirm">
    <header>
      <h6>确认红字发票信息</h6>
    </header>
    <main>
      <div class="card negative-invoice">
        <van-field v-model="invoiceInfo.invoiceCode" label="发票代码" placeholder="自动带入" readonly />
        <van-field v-model="invoiceInfo.invoiceNo" label="发票号码" placeholder="自动带入" readonly />
        <van-field v-model="invoiceInfo.drewDate" label="开票日期" placeholder="自动带入" readonly />
        <EllipticMark :style="{ top: '10px', transform: 'translateY(0)' }" type="error" text="负数发票" />
      </div>
      <div class="card margin-top-16">
        <van-field v-model="invoiceInfo.purchaserName" label="购方名称" placeholder="自动带入" readonly />
        <van-field v-model="invoiceInfo.purchaserTaxNo" label="购方税号" placeholder="自动带入" readonly />
      </div>
      <div class="card margin-top-16">
        <Table
          :tableData="invoiceInfo.details"
          :columns="columns"
        >
        </Table>
      </div>
      <div class="card margin-top-16">
        <van-field v-model="invoiceInfo.amount" label="合计金额" placeholder="自动带入" readonly />
        <van-field v-model="invoiceInfo.taxAmount" label="合计税额" placeholder="自动带入" readonly />
        <van-field v-model="invoiceInfo.amountWithTax" label="价税合计" placeholder="自动带入" readonly />
      </div>
      <ModuleHeadText title="当前销方信息" />
      <div class="card">
        <van-field v-model="invoiceInfo.sellerName" label="销方名称" placeholder="自动带入" readonly />
        <van-field v-model="invoiceInfo.sellerTaxNo" label="纳税人识别号" placeholder="自动带入" readonly />
      </div>
      <div class="card margin-top-16">
        <!-- 此处需要根据是否全电来处理 -->
        <van-field :value="getEnteredBy" label="录入方信息" placeholder="自动带入" readonly />
        <van-field :value="getRedReason" label="红冲原因" placeholder="自动带入" readonly />

        <van-field v-model="invoiceInfo.invoiceCode" label="对应蓝票代码" placeholder="自动带入" readonly />
        <van-field v-model="invoiceInfo.invoiceNo" label="对应蓝票号码" placeholder="自动带入" readonly />
      </div>
      <div class="card margin-top-16">
        <van-field :value="invoiceInfo.remark" label="备注" placeholder="请输入备注" @input="(e) => changeInvoiceInfo('remark', e)" />
      </div>
    </main>
    <footer>
      <div>
        <MainButton
          :handleClick="() => handleBtnClick('return')"
        >
          <span>返回</span>
        </MainButton>
      </div>
      <div>
        <MainButton
          :handleClick="() => handleBtnClick('confirm')"
        >
          <span>开票并上传</span>
        </MainButton>
      </div>
    </footer>
  </div>
</template>

<script>
import { Field, Toast } from 'vant'
import Table from '@/components/Table/index.vue'
import EllipticMark from '@/components/EllipticMark/index.vue'
import MainButton from '@/components/MainButton/index.vue'
import { mapState, mapMutations, mapActions } from 'vuex'
import { taxControlRedReason, allElectricRedReason } from '@/assets/config.js'
import { isAllElectric } from '@utils/basicUtil'
import ModuleHeadText from '@/components/ModuleHeadText/index.vue'
export default {
  components: {
    Table,
    MainButton,
    EllipticMark,
    ModuleHeadText,
    [Field.name]: Field
  },
  computed: {
    ...mapState('invoiceRedModel', ['invoiceInfo', 'applicationType', 'redReason']),
    allElectric () {
      return isAllElectric(this.invoiceInfo.invoiceType)
    },
    getEnteredBy () {
      return this.applicationType === '1' ? '销方申请' : '购方申请'
    },
    getRedReason () {
      return this.allElectric ? allElectricRedReason[this.redReason] : taxControlRedReason[this.redReason]
    }
  },
  data () {
    return {
      remark: '',
      columns: [
        { title: '货物或应税劳务', dataIndex: 'goodsName', width: '107px', type: 'goodName' },
        { title: '含税单价', dataIndex: 'price', width: '69px', align: 'right', type: 'money' },
        { title: '数量', dataIndex: 'quantity', type: 'money' },
        { title: '含税金额', dataIndex: 'amountWithTax', width: '69px', align: 'right', type: 'money' },
        { title: '税率', dataIndex: 'taxRate', type: 'percentage' }
      ]
    }
  },
  mounted () {

  },
  methods: {
    ...mapMutations('invoiceRedModel', ['setInvoiceInfoByField', 'initInvoiceRedInfo']),
    ...mapActions('invoiceRedModel', ['redOffsetInvoice']),
    changeInvoiceInfo (field, value) {
      this.setInvoiceInfoByField({ field, value })
    },
    async handleBtnClick (type) {
      if (type === 'confirm') {
        Toast.loading({
          message: '查询中...',
          duration: 0
        })
        try {
          await this.redOffsetInvoice()
          this.initInvoiceRedInfo()
          this.$router.push('/invoice-list/index')
        } catch (error) {
        } finally {
          Toast.clear({
            clearAll: true
          })
        }
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style lang="less" scoped src="./style.less">
